import { Component, Inject, Input, OnChanges, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { Location } from '@angular/common';
import { ALLOWED_ICON_ORIGINS } from '../../../../../app-icon-origins';
import get from 'lodash-es/get';

@Component({
    selector: 'cms-partial-category-top-component-value-props',
    templateUrl: './value-props.component.html',
    styleUrls: ['./value-props.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class ValuePropsComponent extends CmsPartialComponentClass implements OnChanges {
    @Input() valuePropsRow: any;
    @Input() grayBackgroundRows: any = [];

    private iconDataUris = new Map<string, string>();

    constructor(
        @Inject('environment') environment: any,
        @Inject(PLATFORM_ID) private platformId: string,
        private cdr: ChangeDetectorRef,
        routerService: RouterService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                environment,
                routerService,
                location,
                categoryService,
            },
        });
    }

    ngOnChanges() {
        if (!isPlatformBrowser(this.platformId) || !this.valuePropsRow) return;
        for (const props of get(this.valuePropsRow, 'value_props.value_prop_set', [])) {
            this.fetchIcon(get(props, 'value_prop[0].icon.href', ''));
        }
    }

    getIconUrl(href: string): string {
        return this.iconDataUris.get(href) || '';
    }

    private fetchIcon(href: string) {
        if (!href || this.iconDataUris.has(href)) return;
        try {
            if (!ALLOWED_ICON_ORIGINS.has(new URL(href).origin)) return;
        } catch { return; }
        this.iconDataUris.set(href, '');
        fetch(href)
            .then(r => r.text())
            .then(svg => {
                this.iconDataUris.set(href, `url('data:image/svg+xml;base64,${btoa(svg)}')`);
                this.cdr.markForCheck();
            })
            .catch(() => {});
    }
}
